import script from "./ReceiveView.vue?vue&type=script&setup=true&lang=js"
export * from "./ReceiveView.vue?vue&type=script&setup=true&lang=js"

import "./ReceiveView.vue?vue&type=style&index=0&id=253b119f&scope=true&lang=css"

const __exports__ = script;

export default __exports__